import React from 'react';

/**
 * LocalFiltersActiveBadge - Orange badge showing when tile is using local filters
 *
 * Displays in tile header to indicate local filtering is active.
 * Clickable to clear all local filters (tile will then use global filters).
 *
 * @param {boolean} hasLocalFilters - Whether tile is using local filters
 * @param {number} localFilterCount - Number of active local filters
 * @param {Function} onClearLocalFilters - Callback to clear all local filters
 */
const LocalFiltersActiveBadge = ({
  hasLocalFilters,
  localFilterCount = 0,
  onClearLocalFilters
}) => {
  // Only show badge when tile is using local filters
  if (!hasLocalFilters) {
    return null;
  }

  const handleClick = () => {
    const confirmed = window.confirm(
      `Clear all local filters? This tile will then use global filters instead.\n\n(${localFilterCount} local filter(s) will be cleared)`
    );
    if (!confirmed) return;
    onClearLocalFilters();
  };

  return (
    <button
      onClick={handleClick}
      className="
        flex items-center gap-1.5 px-2.5 py-1
        bg-orange-100 hover:bg-orange-200
        text-orange-800
        border border-orange-300
        rounded-md
        text-xs font-medium
        transition-colors
        focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-1
      "
      title="Click to clear local filters (tile will use global filters)"
    >
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
      </svg>
      <span>Local</span>
      {localFilterCount > 0 && (
        <span className="px-1.5 py-0.5 bg-orange-200 rounded text-xs font-bold">
          {localFilterCount}
        </span>
      )}
    </button>
  );
};

export default LocalFiltersActiveBadge;
